import moment from 'moment';
import fieldsArrayToKeyValueHash from '@/utils/fieldsArrayToKeyValueHash';
import * as DateParser from '@/utils/dateParser';

export const formatObject = data => {
  if (!data || !Object.keys(data).length) {
    return data
  }
  const fields = fieldsArrayToKeyValueHash(data.fields)
  // Further formatting may happen here
  return fields
};

export const formatArray = data => {
  if (!data || !data.length) {
    return data
  }
  return data.map(item => {
    return fieldsArrayToKeyValueHash(item.fields)
  })
};

export const formatKeys = fields => {
  if (!fields) return fields

  if (Array.isArray(fields)) {
    return fields.reduce((arr, value) => {
      if (value.constructor === Object) {
        arr.push(formatKeys(value))
      } else {
        arr.push(formatKeyStr(value))
      }
      return arr
    }, [])
  }

  return Object.keys(fields).reduce((map, key) => {
    if (fields[key].constructor === Object) {
      map[formatKeyStr(key)] = formatKeys(fields[key])
    } else {
      map[formatKeyStr(key)] = fields[key]
    }
    return map
  }, {})
};

const formatKeyStr = key => key.replace(/-/g, '_')

export const formatJsonURL = url => {
  const arr = url.split('/')
  return arr[arr.length - 1]
};

export const keyFromPath = path => {
  return formatJsonURL(path).replace('.json', '')
};

export const orderEventsByDate = data => {
  let arr = data.slice()
  arr.sort((a, b) => {
    const dateA = moment(
      DateParser.formatDateWithSlashes(a.dates.start_date)
    )
    const dateB = moment(
      DateParser.formatDateWithSlashes(b.dates.start_date)
    )
    return dateA.isAfter(dateB) ? 1 : -1
  })
  return arr
}



// WEBPACK FOOTER //
// ./src/utils/dataFormatting.js